import React from 'react';
import { Box, Container, Grid, Typography, Link, Divider } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { Facebook, LinkedIn, Instagram } from '@mui/icons-material';
import { SvgIcon } from '@mui/material';

// Custom X (Twitter) Icon
const XIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M22.46 6.03L15.5 12l6.96 5.97c.34.29.34.79 0 1.08l-1.43 1.43c-.29.34-.79.34-1.08 0L13 14.5l-5.97 6.96c-.29.34-.79.34-1.08 0l-1.43-1.43c-.34-.29-.34-.79 0-1.08L10.5 12 3.54 6.03c-.34-.29-.34-.79 0-1.08L4.97 3.5c.29-.34.79-.34 1.08 0L13 9.5l5.97-6.96c.29-.34.79-.34 1.08 0l1.43 1.43c.34.29.34.79 0 1.08z" />
  </SvgIcon>
);

const Footer = () => {
  return (
    <Box 
      component="footer" 
      sx={{ 
        bgcolor: 'secondary.main', 
        color: 'white',
        py: { xs: 4, md: 6 },
        mt: 'auto',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)'
      }}
    >
      <Container maxWidth="lg">
        <Grid 
          container 
          spacing={{ xs: 4, md: 8 }} 
          sx={{ 
            justifyContent: 'space-between',
            '& > .MuiGrid-item': {
              display: 'flex',
              flexDirection: 'column',
              alignItems: { xs: 'center', md: 'flex-start' }
            }
          }}
        >
          {/* Contact Section */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography 
              variant="h6" 
              sx={{ 
                fontWeight: 600, 
                mb: 2,
                width: '100%',
                textAlign: { xs: 'center', md: 'left' }
              }}
            >
              Contact Us
            </Typography>
            <Box sx={{ 
              mb: 2, 
              lineHeight: 1.8,
              textAlign: { xs: 'center', md: 'left' }
            }}>
              <Typography variant="body2" sx={{ mb: 1 }}>
                120/40/2B/1A, Kasari Masari, Prayagraj, U.P 211011
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>Phone:</strong> (+91) 8299866226
              </Typography>
              <Typography variant="body2">
                <strong>Email:</strong> shoorawelfare@gmail.com
              </Typography>
            </Box>
          </Grid>
          
          {/* Services Section */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography 
              variant="h6" 
              sx={{ 
                fontWeight: 600, 
                mb: 2,
                width: '100%',
                textAlign: { xs: 'center', md: 'left' }
              }}
            >
              Services
            </Typography>
            <Box sx={{ 
              display: 'flex', 
              flexDirection: 'column', 
              gap: 1.5,
              alignItems: { xs: 'center', md: 'flex-start' }
            }}>
              <Link 
                component={RouterLink} 
                to="/services" 
                color="inherit" 
                sx={{ 
                  textDecoration: 'none',
                  '&:hover': {
                    textDecoration: 'underline'
                  }
                }}
              >
                Income Generating Loans
              </Link>
              <Link 
                component={RouterLink} 
                to="/services" 
                color="inherit" 
                sx={{ 
                  textDecoration: 'none',
                  '&:hover': {
                    textDecoration: 'underline'
                  }
                }}
              >
                Joint Liability Group
              </Link>
              <Link 
                component={RouterLink} 
                to="/services" 
                color="inherit" 
                sx={{ 
                  textDecoration: 'none',
                  '&:hover': {
                    textDecoration: 'underline'
                  }
                }}
              >
                Women Empowerment
              </Link>
            </Box>
          </Grid>
          
          {/* Quick Links Section */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography 
              variant="h6" 
              sx={{ 
                fontWeight: 600, 
                mb: 2,
                width: '100%',
                textAlign: { xs: 'center', md: 'left' }
              }}
            >
              Quick Links
            </Typography>
            <Box sx={{ 
              display: 'flex', 
              flexDirection: 'column', 
              gap: 1.5,
              alignItems: { xs: 'center', md: 'flex-start' }
            }}>
              <Link 
                component={RouterLink} 
                to="/about" 
                color="inherit" 
                sx={{ 
                  textDecoration: 'none',
                  '&:hover': {
                    textDecoration: 'underline'
                  }
                }}
              >
                About Us
              </Link>
              <Link 
                component={RouterLink} 
                to="/contact" 
                color="inherit" 
                sx={{ 
                  textDecoration: 'none',
                  '&:hover': {
                    textDecoration: 'underline'
                  }
                }}
              >
                Contact
              </Link>
              <Link 
                component={RouterLink} 
                to="/donation" 
                color="inherit" 
                sx={{ 
                  textDecoration: 'none',
                  '&:hover': {
                    textDecoration: 'underline'
                  }
                }}
              >
                Donate
              </Link>
              <Link 
                component={RouterLink} 
                to="/partners" 
                color="inherit" 
                sx={{ 
                  textDecoration: 'none',
                  '&:hover': {
                    textDecoration: 'underline'
                  }
                }}
              >
                Partners
              </Link>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: { xs: 3, md: 4 }, borderColor: 'rgba(255, 255, 255, 0.1)' }} />
        
        {/* Footer Bottom Section */}
        <Box sx={{ 
          display: 'flex', 
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: 'space-between', 
          alignItems: 'center',
          gap: 2
        }}>
          <Typography variant="body2" sx={{ textAlign: { xs: 'center', md: 'left' } }}>
            © {new Date().getFullYear()} Shoora Welfare Foundation. All rights reserved.
          </Typography>

          {/* Social Media Section */}
          <Box sx={{ 
            display: 'flex', 
            gap: 2 
          }}>
            <Link 
              href="https://www.facebook.com/shoorawelfare" 
              target="_blank" 
              color="inherit" 
              sx={{ 
                '&:hover': { color: 'primary.light' },
                fontSize: '1.8rem'
              }}
            >
              <Facebook />
            </Link>
            <Link 
              href="https://x.com/shoorawelfare" 
              target="_blank" 
              color="inherit" 
              sx={{ 
                '&:hover': { color: 'primary.light' },
                fontSize: '1.8rem'
              }}
            >
              <XIcon />
            </Link>
            <Link 
              href="https://linkedin.com" 
              target="_blank" 
              color="inherit" 
              sx={{ 
                '&:hover': { color: 'primary.light' },
                fontSize: '1.8rem'
              }}
            >
              <LinkedIn />
            </Link>
            <Link 
              href="https://instagram.com" 
              target="_blank" 
              color="inherit" 
              sx={{ 
                '&:hover': { color: 'primary.light' },
                fontSize: '1.8rem'
              }}
            >
              <Instagram />
            </Link>
          </Box>

          <Box sx={{ 
            display: 'flex', 
            gap: { xs: 2, md: 3 },
            flexWrap: 'wrap',
            justifyContent: 'center'
          }}>
            <Link 
              component={RouterLink} 
              to="/terms" 
              color="inherit" 
              sx={{ 
                textDecoration: 'none',
                '&:hover': {
                  textDecoration: 'underline'
                }
              }}
            >
              Terms of Service
            </Link>
            <Link 
              component={RouterLink} 
              to="/privacy-policy" 
              color="inherit" 
              sx={{ 
                textDecoration: 'none',
                '&:hover': {
                  textDecoration: 'underline'
                }
              }}
            >
              Privacy Policy
            </Link>
            <Link 
              component={RouterLink} 
              to="/grievance-policy" 
              color="inherit" 
              sx={{ 
                textDecoration: 'none',
                '&:hover': {
                  textDecoration: 'underline'
                }
              }}
            >
              Grievance Policy
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;